import { render, staticRenderFns } from "./MobileContainerTrackingSearchResultItem.vue?vue&type=template&id=ca28333e&scoped=true&"
import script from "./MobileContainerTrackingSearchResultItem.vue?vue&type=script&lang=js&"
export * from "./MobileContainerTrackingSearchResultItem.vue?vue&type=script&lang=js&"
import style0 from "./MobileContainerTrackingSearchResultItem.vue?vue&type=style&index=0&id=ca28333e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca28333e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca28333e')) {
      api.createRecord('ca28333e', component.options)
    } else {
      api.reload('ca28333e', component.options)
    }
    module.hot.accept("./MobileContainerTrackingSearchResultItem.vue?vue&type=template&id=ca28333e&scoped=true&", function () {
      api.rerender('ca28333e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/vsl/ContainerTrackingSearch/MobileContainerTrackingSearchResultItem.vue"
export default component.exports